import React, { useState } from 'react';

import {
  Box,
  LinearProgress,
  Typography,
  Rating,
  Paper,
  Popper,
  ClickAwayListener
} from '@mui/material';

const ratingStats = [
  { stars: 5, percentage: 100, label: 'Answered matched' },
  { stars: 4, percentage: 80 },
  { stars: 3, percentage: 65 },
  { stars: 2, percentage: 40 },
  { stars: 1, percentage: 20 },
  { stars: 0, percentage: 0, label: 'Less then 20%' }
];

const RatingStatistics = () => (
  <Box sx={{ p: 2, width: 400 }}>
    {ratingStats.map((rating) => (
      <Box
        key={rating.stars}
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1,
          gap: 1
        }}
      >
        <Box sx={{ minWidth: 120, display: 'flex', alignItems: 'center' }}>
          <Rating
            value={rating.stars}
            readOnly
            precision={1}
          />
        </Box>

        <Box sx={{ flex: 1, mr: 1, bgcolor: '#FCFCFC' }}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Box sx={{ minWidth: 60 }}>
              <Typography fontFamily='Lato' fontSize='11px' fontWeight={500}>
                {rating.percentage > 0 ? `${rating.percentage}%` : ''}
              </Typography>
            </Box>

            {rating.label && (
              <Typography fontFamily='Lato' fontSize='11px' fontWeight={500}>
                {rating.label}
              </Typography>
            )}
          </Box>
          <LinearProgress
            variant="determinate"
            value={rating.percentage}
            sx={{
              height: 8,
              borderRadius: 5,
              backgroundColor: '#F0F0F0',
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#FFB400',
                borderRadius: 5,
              }
            }}
          />
        </Box>


      </Box>
    ))}
  </Box>
);

const QnaRating = ({ value = 0 }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState();

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setPlacement('right');
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', position: 'relative' }}>
      <Box
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Rating
          value={value}
          readOnly
          sx={{
            color: '#FFB400',
            '& .MuiRating-iconFilled': {
              color: '#FFB400'
            }
          }}
        />
      </Box>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        sx={{ zIndex: 1000 }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper elevation={3} sx={{ mt: 1 }}>
            <RatingStatistics />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default QnaRating;